import { Link } from 'react-router-dom';
import './EventActions.css';

function EventActions({ eventLink, onAddToCalendar }) {
  return (
    <div className="event-actions">
      <button className="btn-primary" onClick={onAddToCalendar}>
        <i className="fa-regular fa-calendar-plus"></i> Aggiungi al Calendario
      </button>
      {eventLink && (
        <a href={eventLink} target="_blank" rel="noopener noreferrer" className="btn-secondary">
          <i className="fa-solid fa-up-right-from-square"></i> Link Evento
        </a>
      )}
      <Link to="/contact" className="btn-secondary">
        <i className="fa-regular fa-envelope"></i> Contattaci per Info
      </Link>
    </div>
  );
}

export default EventActions;
